import React from "react";

// Lightweight shimmer skeleton. Use for loading states.
//   <Skeleton h={20} w="60%" />
//   <Skeleton.Row count={5} />
//   <Skeleton.Card />

export default function Skeleton({ h = 14, w = "100%", radius = 8, style = {} }) {
  return (
    <div
      className="ds-skeleton"
      style={{ height: h, width: w, borderRadius: radius, ...style }}
    />
  );
}

Skeleton.Row = function Row({ count = 3, gap = 8 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap }}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} h={12} w={`${60 + (i % 3) * 15}%`} />
      ))}
    </div>
  );
};

Skeleton.Card = function CardSkel() {
  return (
    <div className="ds-card" style={{ padding: 16 }}>
      <Skeleton h={11} w="40%" />
      <Skeleton h={28} w="55%" style={{ marginTop: 10 }} />
      <Skeleton h={11} w="30%" style={{ marginTop: 12 }} />
    </div>
  );
};
